import { render, staticRenderFns } from "./goodsClose.vue?vue&type=template&id=1f20a2e4&scoped=true&"
import script from "./goodsClose.vue?vue&type=script&lang=js&"
export * from "./goodsClose.vue?vue&type=script&lang=js&"
import style0 from "./goodsClose.vue?vue&type=style&index=0&id=1f20a2e4&lang=scss&scoped=true&"
import style1 from "./goodsClose.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f20a2e4",
  null
  
)

export default component.exports